import api from "@/core/api";

export const messageRead = () => api.query(`/messages`);
export const messageDelete = (id: string) => api.query(`/messages/${id}`, { method: "delete" });
